var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",class:_vm.cssClass},[_c('span',{staticClass:"spinner-border spinner-border-sm align-middle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }